import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchCredentials } from "redux/actions/portal/credentialManagementActionCreator";
import { useAuth0 } from "@auth0/auth0-react";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { PERMISSIONS } from "constants/portal";
import { permissionChecker } from "../helpers/common";

export const useCredentials = () => {
  const { user } = useAuth0();
  const { credentials } = useSelector((store) => store?.portal?.credentialManagement);
  const dispatch = useDispatch();
  const { userPermissions } = useContext(PermissionsContext);

  const handleFetchCredentials = () => {
    dispatch(
      fetchCredentials(
        user?.stripeId,
        permissionChecker(userPermissions, PERMISSIONS.VIEW_ANY_CREDENTIALS)
          ? undefined
          : user?.cxfUserId
      )
    );
  };

  useEffect(() => {
    if (!user) return;

    if (!credentials.length) {
      handleFetchCredentials();
    }
  }, [user]);

  return {
    credentials,
    handleFetchCredentials
  };
};
